var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCardVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 22.1064,
    height: 17,
    rx: 3.5,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 12H7.8723C7.53372 12 7.20902 12.1345 6.96961 12.3739C6.7302 12.6133 6.5957 12.938 6.5957 13.2766C6.5957 13.6152 6.7302 13.9399 6.96961 14.1793C7.20902 14.4187 7.53372 14.5532 7.8723 14.5532H17.4468C17.7853 14.5532 18.11 14.4187 18.3495 14.1793C18.5889 13.9399 18.7234 13.6152 18.7234 13.2766C18.7234 12.938 18.5889 12.6133 18.3495 12.3739C18.11 12.1345 17.7853 12 17.4468 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 6.04248H7.8723C7.53372 6.04248 7.20902 6.17698 6.96961 6.41639C6.7302 6.6558 6.5957 6.9805 6.5957 7.31908C6.5957 7.65765 6.7302 7.98236 6.96961 8.22177C7.20902 8.46117 7.53372 8.59567 7.8723 8.59567H17.4468C17.7853 8.59567 18.11 8.46117 18.3495 8.22177C18.5889 7.98236 18.7234 7.65765 18.7234 7.31908C18.7234 6.9805 18.5889 6.6558 18.3495 6.41639C18.11 6.17698 17.7853 6.04248 17.4468 6.04248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCardVisit);
export default __webpack_public_path__ + "static/media/icon_chat_card_visit.9cfa0d6f03992b5a76e094b5d5d33f26.svg";
export { ForwardRef as ReactComponent };